import React from 'react';
import { Card } from 'primereact/card';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';
import { CoachingTabs } from '../../../../utils/typeConstants';

interface ExploreSectionProps {
    exploreNotes: string;
    onExploreNotesChange: (value: string) => void;
}

export const ExploreSection: React.FC<ExploreSectionProps> = ({
    exploreNotes,
    onExploreNotesChange
}) => {
    const exploreQuestions = [
        '"Where do you want to be in the next 2 weeks if everything goes exactly as we plan together. What does success look like for you? Do you think you can improve on communication skills with reducing this metric?"',
        `"Let's picture the ideal outcome of our work together. What specific results would make you feel proud and accomplished?"`,
        '"What goals do you want us to focus on so by the end of this coaching session, you feel you have made real progress? Do you agree to go through the metric goals?"',
        '"Describe the change in behavior or skills you want to improve as a result of our collaboration. How will that impact the NPS score that you want to meet based on the targets?"',
        '"If we were to work on your skills of active listening and answering with patience to achieve your goals perfectly, do you think these would help with your metric?"'
    ];

    return (
        <div className="fuel-section-content">
            <h4 className="section-title">Explore the Desired Goal</h4>
            <p className="section-subtitle">
                Encourage the associate to envision desired outcomes or goal that you both 
                want to achieve together. Guide <strong>SMART</strong> goals inline with the <strong>U</strong> phase.
            </p>

            <Card className="examples-card-explore">
                <h5>Example Questions:</h5>
                <ul className="examples-list explore-questions">
                    {exploreQuestions.map((question, index) => (
                        <li key={index}>{question}</li>
                    ))}
                </ul>
            </Card>

            

            <div className="notes-section">
                <DescriptionBox
                    title='Exploration Notes'
                    responseDescription={exploreNotes}
                    value={exploreNotes}
                    limit={4000}
                    onChange={(val: string) => onExploreNotesChange(val)}
                    via={CoachingTabs.CoachingActionPlan}
                />
            </div>
        </div>
    );
};
